import type { SubscriptionInfo, SubscriptionTitles } from '@/features/jw-pro/types';

import { WebLocale } from '@/enums/web-locale';

// EXP_JW_PRO_PRICING
import { PRICING_EXP_SUBSCRIPTIONS } from '@/components/experiments/JwProPricingExp/helper';
// EXP_JW_PRO_PRICING

export const DefaultSubscriptionInfo: SubscriptionInfo = {
	id: '',
	type: 'regular',
	timeframe: 'monthly',
	prices: {
		DEFAULT: {
			price: 2.49,
			currency: 'EUR',
			priceId: '',
		},
	},
};

// Supported weblocales on mobile (individual features are responsible for locked/unlocked state)
export const IapWebLocales = [
	WebLocale.at,
	WebLocale.au,
	WebLocale.be,
	WebLocale.bg,
	WebLocale.ca,
	WebLocale.ch,
	WebLocale.cz,
	WebLocale.de,
	WebLocale.dk,
	WebLocale.ee,
	WebLocale.eg,
	WebLocale.es,
	WebLocale.fi,
	WebLocale.fr,
	WebLocale.gr,
	WebLocale.hr,
	WebLocale.hu,
	WebLocale.ie,
	WebLocale.in,
	WebLocale.it,
	WebLocale.lt,
	WebLocale.lv,
	WebLocale.nl,
	WebLocale.nz,
	WebLocale.ph,
	WebLocale.pl,
	WebLocale.pt,
	WebLocale.ro,
	WebLocale.se,
	WebLocale.sk,
	WebLocale.uk,
	WebLocale.us,
	WebLocale.za,
];

/** JW Pro Web countries. */
export const ActiveProWebLocales = [
	WebLocale.us,
	WebLocale.de,
	WebLocale.at,
	WebLocale.ie,
	WebLocale.fr,
	WebLocale.es,
	WebLocale.it,
	WebLocale.pl,
	WebLocale.nl,
	WebLocale.se,
	WebLocale.fi,
	WebLocale.be,
	WebLocale.pt,
	WebLocale.cz,
	WebLocale.ro,
	WebLocale.uk,
	WebLocale.au,
];

const prodSubscriptions: Record<SubscriptionTitles, SubscriptionInfo> = {
	regular: {
		id: 'prod_NzlSDe5AXBSi4X',
		type: 'regular',
		timeframe: 'monthly',
		prices: {
			DEFAULT: {
				priceId: 'price_1NDlvNKD0TTmBHo08pBWfjIZ',
				price: 3.99,
				currency: 'EUR',
			},
			IN: {
				priceId: 'price_1ReaHBKD0TTmBHo0bPgoWc8W',
				price: 120,
				currency: 'INR',
			},
			EG: {
				priceId: 'price_1ReaIGKD0TTmBHo0HKVutxIe',
				price: 35,
				currency: 'EGP',
			},
			CA: {
				priceId: 'price_1ReaHdKD0TTmBHo0P4ymUMW6',
				price: 5.75,
				currency: 'CAD',
			},
			PH: {
				priceId: 'price_1ReaIcKD0TTmBHo0JJWG2tdT',
				price: 90,
				currency: 'PHP',
			},
			AU: {
				priceId: 'price_1ReaJoKD0TTmBHo0gWnQDFbp',
				price: 6,
				currency: 'AUD',
			},
			TR: {
				priceId: 'price_1ReaJ2KD0TTmBHo0OqEfFy8B',
				price: 115,
				currency: 'TRY',
			},
		},
	},
	OldRegular: {
		id: 'prod_LKEY8MLBOZwwQN',
		type: 'regular',
		timeframe: 'monthly',
		prices: {
			DEFAULT: {
				priceId: 'price_1Kda5MKD0TTmBHo0KnyileCK',
				price: 2.49,
				currency: 'EUR',
			},
		},
	},
	proPricingExpRegular: {
		id: 'prod_Qc46dauFAQTGlu',
		type: 'regular',
		timeframe: 'monthly',
		prices: {
			DEFAULT: {
				priceId: 'price_1Pkpy0KD0TTmBHo0ZF27wWbJ',
				price: 2.49,
				currency: 'EUR',
			},
		},
	},
	// EXP_JW_PRO_PRICING
	...PRICING_EXP_SUBSCRIPTIONS,
	// EXP_JW_PRO_PRICING
	yearly: {
		id: 'prod_NzlZqI8lGP1soA',
		type: 'regular',
		timeframe: 'yearly',
		prices: {
			DEFAULT: {
				priceId: 'price_1NDm2ZKD0TTmBHo0u99J14yr',
				price: 19.99,
				currency: 'EUR',
			},
		},
	},
	onetime: {
		id: 'prod_NzlbbPqyeBPsT8',
		type: 'regular',
		timeframe: 'one time',
		prices: {
			DEFAULT: {
				priceId: 'price_1NDm4CKD0TTmBHo0KnsX1AJw',
				price: 59.99,
				currency: 'EUR',
			},
		},
	},
	justWatchTvProControl: {
		id: 'prod_SZjLzGnkM9i3yW',
		timeframe: 'monthly',
		type: 'regular',
		prices: {
			DEFAULT: {
				priceId: 'price_1ReZt4KD0TTmBHo08wV6amDc',
				price: 3.99,
				currency: 'EUR',
			},
			IN: {
				priceId: 'price_1ReZxwKD0TTmBHo0oct6DPbW',
				price: 120,
				currency: 'INR',
			},
			EG: {
				priceId: 'price_1ReZwpKD0TTmBHo0gExm45G6',
				price: 35,
				currency: 'EGP',
			},
			TR: {
				priceId: 'price_1ReZxgKD0TTmBHo03oKcK0GV',
				price: 115,
				currency: 'TRY',
			},
			PH: {
				priceId: 'price_1ReZyNKD0TTmBHo0WyGlKLyV',
				price: 90,
				currency: 'PHP',
			},
			US: {
				priceId: 'price_1ReZyiKD0TTmBHo0GxYyIzoT',
				price: 3.99,
				currency: 'USD',
			},
			CA: {
				priceId: 'price_1ReZwPKD0TTmBHo0Wywxo2OL',
				price: 5.75,
				currency: 'CAD',
			},
			AU: {
				priceId: 'price_1ReZvAKD0TTmBHo0smm47glq',
				price: 6.0,
				currency: 'AUD',
			},
		},
	},
	justWatchTvProV1: {
		id: 'prod_SZjUlkXI9c05I2',
		timeframe: 'monthly',
		type: 'regular',
		prices: {
			DEFAULT: {
				priceId: 'price_1Rea1CKD0TTmBHo03MPIdbBi',
				price: 3.99,
				currency: 'EUR',
			},
			IN: {
				priceId: 'price_1Rea1CKD0TTmBHo0lJ5zrm6i',
				price: 120,
				currency: 'INR',
			},
			EG: {
				priceId: 'price_1Rea1CKD0TTmBHo0Ak7bTst6',
				price: 35,
				currency: 'EGP',
			},
			TR: {
				priceId: 'price_1Rea1CKD0TTmBHo0V72KQ1v4',
				price: 115,
				currency: 'TRY',
			},
			PH: {
				priceId: 'price_1Rea1CKD0TTmBHo0SLhUOrgt',
				price: 90,
				currency: 'PHP',
			},
			US: {
				priceId: 'price_1Rea1CKD0TTmBHo07wY4sCYC',
				price: 3.99,
				currency: 'USD',
			},
			CA: {
				priceId: 'price_1Rea1CKD0TTmBHo085wJQFkL',
				price: 5.75,
				currency: 'CAD',
			},
			AU: {
				priceId: 'price_1Rea1CKD0TTmBHo0IfK8BWxS',
				price: 6.0,
				currency: 'AUD',
			},
		},
	},
	justWatchTvProV2: {
		id: 'prod_SZjZn5zS0BsLpN',
		timeframe: 'monthly',
		type: 'regular',
		prices: {
			DEFAULT: {
				priceId: 'price_1Rea6SKD0TTmBHo0q4GEptLN',
				price: 3.99,
				currency: 'EUR',
			},
			IN: {
				priceId: 'price_1Rea6SKD0TTmBHo0fXxFA56J',
				price: 120,
				currency: 'INR',
			},
			EG: {
				priceId: 'price_1Rea6SKD0TTmBHo08Lh7omAh',
				price: 35,
				currency: 'EGP',
			},
			TR: {
				priceId: 'price_1Rea6SKD0TTmBHo0RvhezeR9',
				price: 115,
				currency: 'TRY',
			},
			PH: {
				priceId: 'price_1Rea6SKD0TTmBHo0uXXuAswb',
				price: 90,
				currency: 'PHP',
			},
			US: {
				priceId: 'price_1Rea6SKD0TTmBHo04c42gMQ0',
				price: 3.99,
				currency: 'USD',
			},
			CA: {
				priceId: 'price_1Rea6SKD0TTmBHo0DQdlhubI',
				price: 5.75,
				currency: 'CAD',
			},
			AU: {
				priceId: 'price_1Rea6RKD0TTmBHo0Lrxq4J8O',
				price: 6.0,
				currency: 'AUD',
			},
		},
	},
};

const stageSubscriptions: Record<SubscriptionTitles, SubscriptionInfo> = {
	OldRegular: {
		id: 'prod_LEXxxyuYn89OPR',
		type: 'regular',
		timeframe: 'monthly',
		prices: {
			DEFAULT: { priceId: 'price_1KY4rdKD0TTmBHo0G6QF7lvI', price: 2.49, currency: 'EUR' },
		},
	},
	regular: {
		id: 'prod_LEXxxyuYn89OPR',
		type: 'regular',
		timeframe: 'monthly',
		prices: {
			DEFAULT: { priceId: 'price_1PzeIzKD0TTmBHo0tVXUCfNM', price: 3.99, currency: 'EUR' },
			IN: { priceId: 'price_1Rd9ycKD0TTmBHo0mr98l4kP', price: 120, currency: 'INR' },
			EG: { priceId: 'price_1Rd9xwKD0TTmBHo0QUXTAnPj', price: 35, currency: 'EGP' },
			TR: { priceId: 'price_1Rd9xRKD0TTmBHo0U2atJBo9', price: 113, currency: 'TRY' },
			PH: { priceId: 'price_1Rd9yGKD0TTmBHo00OWYBRGj', price: 90, currency: 'PHP' },
			CA: { priceId: 'price_1ReEMyKD0TTmBHo0lDw2uV0G', price: 5.75, currency: 'CAD' },
			AU: { priceId: 'price_1ReENDKD0TTmBHo0c8x5cExg', price: 6.0, currency: 'AUD' },
		},
	},
	proPricingExpRegular: {
		id: 'prod_LEXxxyuYn89OPR',
		type: 'regular',
		timeframe: 'monthly',
		prices: {
			DEFAULT: { priceId: 'price_1PzeIzKD0TTmBHo0tVXUCfNM', price: 3.99, currency: 'EUR' },
		},
	},
	// EXP_JW_PRO_PRICING
	...PRICING_EXP_SUBSCRIPTIONS,
	// EXP_JW_PRO_PRICING
	yearly: {
		id: 'prod_O23uFKbUh3bxcU',
		type: 'regular',
		timeframe: 'yearly',
		prices: {
			DEFAULT: { priceId: 'price_1NFzmCKD0TTmBHo0UtZeudXs', price: 19.99, currency: 'EUR' },
		},
	},
	onetime: {
		id: 'prod_O23t7WVLZBADYQ',
		type: 'regular',
		timeframe: 'one time',
		prices: {
			DEFAULT: { priceId: 'price_1NFzlGKD0TTmBHo0UoDXktCz', price: 59.99, currency: 'EUR' },
		},
	},
	justWatchTvProControl: {
		id: 'prod_SYGTQog2KKU1A9',
		type: 'regular',
		timeframe: 'monthly',
		prices: {
			DEFAULT: { priceId: 'price_1Rd9wJKD0TTmBHo05GegQQ4n', price: 3.99, currency: 'EUR' },
			IN: { priceId: 'price_1Rd9ycKD0TTmBHo0mr98l4kP', price: 120, currency: 'INR' },
			EG: { priceId: 'price_1Rd9xwKD0TTmBHo0QUXTAnPj', price: 35, currency: 'EGP' },
			TR: { priceId: 'price_1Rd9xRKD0TTmBHo0U2atJBo9', price: 113, currency: 'TRY' },
			PH: { priceId: 'price_1Rd9yGKD0TTmBHo00OWYBRGj', price: 90, currency: 'PHP' },
			US: { priceId: 'price_1ReEH6KD0TTmBHo00CL8i6gq', price: 3.99, currency: 'USD' },
			CA: { priceId: 'price_1ReEMyKD0TTmBHo0lDw2uV0G', price: 5.75, currency: 'CAD' },
			AU: { priceId: 'price_1ReENDKD0TTmBHo0c8x5cExg', price: 6.0, currency: 'AUD' },
		},
	},
	justWatchTvProV1: {
		id: 'prod_SYGTQog2KKU1A9',
		type: 'regular',
		timeframe: 'monthly',
		prices: {
			DEFAULT: { priceId: 'price_1Rd9wJKD0TTmBHo05GegQQ4n', price: 3.99, currency: 'EUR' },
			IN: { priceId: 'price_1Rd9ycKD0TTmBHo0mr98l4kP', price: 120, currency: 'INR' },
			EG: { priceId: 'price_1Rd9xwKD0TTmBHo0QUXTAnPj', price: 35, currency: 'EGP' },
			TR: { priceId: 'price_1Rd9xRKD0TTmBHo0U2atJBo9', price: 113, currency: 'TRY' },
			PH: { priceId: 'price_1Rd9yGKD0TTmBHo00OWYBRGj', price: 90, currency: 'PHP' },
			US: { priceId: 'price_1ReEH6KD0TTmBHo00CL8i6gq', price: 3.99, currency: 'USD' },
			CA: { priceId: 'price_1ReEMyKD0TTmBHo0lDw2uV0G', price: 5.75, currency: 'CAD' },
			AU: { priceId: 'price_1ReENDKD0TTmBHo0c8x5cExg', price: 6.0, currency: 'AUD' },
		},
	},
	justWatchTvProV2: {
		id: 'prod_SYGTQog2KKU1A9',
		type: 'regular',
		timeframe: 'monthly',
		prices: {
			DEFAULT: { priceId: 'price_1Rd9wJKD0TTmBHo05GegQQ4n', price: 3.99, currency: 'EUR' },
			IN: { priceId: 'price_1Rd9ycKD0TTmBHo0mr98l4kP', price: 120, currency: 'INR' },
			EG: { priceId: 'price_1Rd9xwKD0TTmBHo0QUXTAnPj', price: 35, currency: 'EGP' },
			TR: { priceId: 'price_1Rd9xRKD0TTmBHo0U2atJBo9', price: 113, currency: 'TRY' },
			PH: { priceId: 'price_1Rd9yGKD0TTmBHo00OWYBRGj', price: 90, currency: 'PHP' },
			US: { priceId: 'price_1ReEH6KD0TTmBHo00CL8i6gq', price: 3.99, currency: 'USD' },
			CA: { priceId: 'price_1ReEMyKD0TTmBHo0lDw2uV0G', price: 5.75, currency: 'CAD' },
			AU: { priceId: 'price_1ReENDKD0TTmBHo0c8x5cExg', price: 6.0, currency: 'AUD' },
		},
	},
};

export const SUBSCRIPTIONS: Record<SubscriptionTitles, SubscriptionInfo> =
	BUILD_CONFIG.env === 'prod' ? prodSubscriptions : stageSubscriptions;
